import TooltipInfo from '@components/TooltipInfo'
import { Button } from 'antd'
import { SizeType } from 'antd/lib/config-provider/SizeContext'
import cx from 'classnames'
import React, { memo } from 'react'

import InputHint from '../InputHint'

enum Colors {
  default,
  red,
  blue,
  green,
  black,
  yellow,
}

type ColorType = keyof typeof Colors

type Props = {
  children?: React.ReactNode
  className?: string
  color?: ColorType
  size?: SizeType
  rounded?: boolean
  circle?: boolean
  outline?: boolean
  dashed?: boolean
  disabled?: boolean
  tooltip?: React.ReactElement
  onClick?: (e: any) => void
  loading?: boolean
  title?: string
  [rest: string]: any
}

export const AppButton = memo(
  ({
    children = null,
    className = '',
    color = 'default',
    rounded = true,
    circle = false,
    outline = false,
    dashed = false,
    loading = false,
    disabled = false,
    size = 'middle',
    tooltip = null,
    onClick = (e: any) => {},
    title = null,
    ...rest
  }: Props) => {
    const colorClassName = () => {
      if (outline) {
        return `${color}-outline`
      }
      if (dashed) {
        return `${color}-outline-dashed`
      }
      return color
    }

    const getShapeClassName = () => {
      if (circle) {
        return 'circle'
      }

      if (rounded) {
        return 'round'
      }
    }

    const colorText = colorClassName()

    const handleClick = (e: any) => {
      if (disabled) {
        e.preventDefault()
        e.stopPropagation()
        return
      }
      if (onClick) {
        onClick(e)
      }
    }

    return (
      <Button
        shape={getShapeClassName()}
        loading={loading}
        onClick={handleClick}
        className={cx([
          'inline-flex items-center justify-center',
          disabled ? 'bg-grey-400 cursor-not-allowed' : 'cursor-pointer',
          className,
          `btn-${colorText}`,
        ])}
        size={size}
        title={title}
        {...rest}
      >
        {children}
        {tooltip && <TooltipInfo iconColor="text-white" text={tooltip} />}
        <InputHint text={rest.hint} />
      </Button>
    )
  }
)
